import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { UserSharingPermissionFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateUserSharingPermissionsMutationVariables = Types.Exact<{
  input: Types.CreateUserSharingPermissionsInput;
}>;


export type CreateUserSharingPermissionsMutation = { __typename?: 'Mutation', createUserSharingPermissions: { __typename?: 'UserSharingPermissionMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, userSharingPermissions?: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> | null } };


export const CreateUserSharingPermissionsDocument = gql`
    mutation createUserSharingPermissions($input: CreateUserSharingPermissionsInput!) {
  createUserSharingPermissions(input: $input) {
    success
    error {
      code
      message
    }
    userSharingPermissions {
      ...UserSharingPermission
    }
  }
}
    ${UserSharingPermissionFragmentDoc}`;
export type CreateUserSharingPermissionsMutationFn = Apollo.MutationFunction<CreateUserSharingPermissionsMutation, CreateUserSharingPermissionsMutationVariables>;

/**
 * __useCreateUserSharingPermissionsMutation__
 *
 * To run a mutation, you first call `useCreateUserSharingPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSharingPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSharingPermissionsMutation, { data, loading, error }] = useCreateUserSharingPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserSharingPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserSharingPermissionsMutation, CreateUserSharingPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserSharingPermissionsMutation, CreateUserSharingPermissionsMutationVariables>(CreateUserSharingPermissionsDocument, options);
      }
export type CreateUserSharingPermissionsMutationHookResult = ReturnType<typeof useCreateUserSharingPermissionsMutation>;
export type CreateUserSharingPermissionsMutationResult = Apollo.MutationResult<CreateUserSharingPermissionsMutation>;
export type CreateUserSharingPermissionsMutationOptions = Apollo.BaseMutationOptions<CreateUserSharingPermissionsMutation, CreateUserSharingPermissionsMutationVariables>;